import { useEffect, useState } from 'react';

import { Alert } from '@zooplus/ui-components';

import { useTranslation } from '@hooks/useTranslations';
import { useAppContext } from '@providers/AppContextProvider';
import { RetryPaymentIdealData, getRetryPaymentIdealData } from '@services/retryPaymentService';
import { getMobileAppType, isRecognizedApp } from '@utils/retryUtils';

export type RetryPaymentIdealProps = {
  onError: (errorMessage: string) => void;
  orderId: string;
  customerId: string;
};

const RetryPaymentIdeal: React.FC<RetryPaymentIdealProps> = ({ onError, orderId, customerId }) => {
  const { t } = useTranslation();
  const [idealData, setIdealData] = useState<RetryPaymentIdealData>();
  const { domain, locale } = useAppContext();
  const [mobileAppType] = useState(() => {
    return getMobileAppType();
  });
  const isMobileApp = isRecognizedApp(mobileAppType) ?? false;

  useEffect(() => {
    (async () => {
      try {
        const result = await getRetryPaymentIdealData({
          orderId,
          customerId,
          domain,
          isMobileApp,
          locale,
        });
        setIdealData(result.data);
        console.log('Retry payment IDeal data', result.data);
      } catch (error: any) {
        onError(t('checkout.payment.creditcard.error.selectcard.apicall'));
      }
    })();
  }, [t, onError, orderId, domain, locale]);

  if (!idealData) {
    return null;
  }

  const { transactionId, transactionUrl } = idealData;

  if (transactionId) {
    return (
      <Alert data-zta="retryPaymentIdealSuccess" variant="success">
        {t('order.ideal.paymentsuccessful', {
          '0': transactionId,
        })}
      </Alert>
    );
  }
  if (transactionUrl) {
    const handleClick = () => {
      window.location.replace(transactionUrl);
    };

    return (
      <Alert
        data-zta="paymentRedirectButton"
        variant="warning"
        buttonText={t('order.ideal.payButtonText')}
        onButtonClick={handleClick}>
        {t('order.ideal.hint')}
      </Alert>
    );
  }
  return (
    <Alert data-zta="retryPaymentIdealError" variant="warning">
      {t('order.ideal.error')}
    </Alert>
  );
};

export default RetryPaymentIdeal;
